
        <div class="alert toggle-alert alert-{{type}}" [ngClass]="{active : showMessage}">
            <div class="row">
                <div class="col">
                    <div *ngFor="let error of errorMessage">{{ error }} </div>
                </div>
                <!--<div class="col-auto">
                    <span aria-hidden="true"  (click)="closeMessage()">×</span>
                </div>-->
            </div>
		</div>